export default function Openings() {
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-emerald-600 text-xs uppercase tracking-widest mb-6 font-medium">
            Join Our Team
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 leading-tight mb-6">
            We are a growing company with big ambitions.
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed">
            Check back here regularly for advertised positions.
          </p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="bg-emerald-50/60 border-2 border-dashed border-emerald-200 rounded-3xl p-10 md:p-12 text-center">
            <div className="w-16 h-16 flex items-center justify-center mx-auto mb-6 bg-emerald-100 rounded-full">
              <i className="ri-briefcase-line text-2xl text-emerald-700"></i>
            </div>
            <h3 className="text-2xl font-serif font-bold text-gray-900 mb-3">
              No open positions right now
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed max-w-md mx-auto">
              We're always growing, so check back soon. When a new role opens up, it will be listed right here.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}